module.exports = __webpack_public_path__ + "assets/img/logo_new.89fd290a.svg";